import * as React from 'react'
import { createPortal } from 'react-dom'

import { AnimatePresence, motion } from 'framer-motion'

import { observer } from 'mobx-react'

import Flash from 'modules/core/components/Flash'
import type { Flash as FlashProps } from 'modules/core/store/models/app'
import app from 'modules/core/store/models/app'

import * as styles from './index.vanilla.css'

const AnimatedFlash = () => {
  const closeFlash = () => {
    app.setFlash(null)
  }

  return createPortal(
    <AnimatePresence>
      {Boolean(app.flash) && (
        <motion.div
          className={styles.flash}
          transition={{ duration: 0.3, type: 'linear' }}
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -20, opacity: 0 }}
        >
          <Flash {...(app.flash as FlashProps)} close={closeFlash} />
        </motion.div>
      )}
    </AnimatePresence>,
    document.body
  )
}

export default observer(AnimatedFlash)
